module.exports = __webpack_public_path__ + "img/book-section.74f5e7c4.svg";